module.exports = __webpack_public_path__ + "img/shift-validation-success.4a9a71d1.webp";